<template>
  <b-container>
    <small>{{ uitvoeringPath }}</small>
    <periode-hinder 
      :hinder="hinder" 
      @update-periode="onUpdatePeriode"
    />
    
    <hinder-details :hinder="hinder" />

    <b-table 
      :fields="['Omschrijving',{label:'Datum',key:'Op'},{label:'Voor',key:'ToegewezenAan'},{label:'Controle',key:'Auditor'}]" 
      :items="extraTaken"
      small
      fixed
      bordered
      striped
    >
      <template #cell(Omschrijving)="row">
        <b-checkbox v-model="row.item.Actief">
          {{ row.item.Omschrijving }}
        </b-checkbox>
      </template>
      <template #cell(Op)="row">
        <date-input 
          :date="row.item.Datum || null"
          placeholder="Op" 
          @date-changed="row.item.Datum = $event !== null ? $event.toISOString() : null"
        /> 
      </template>
      <template #cell(ToegewezenAan)="row">
        <b-select 
          v-model="row.item.Toegewezen_Aan" 
          :options="personen.map(o => {
            return {
              text: o.Naam.split(' ')[0],
              value: o
            }
          })"
        >
          <template #first>
            <b-form-select-option 
              :value="null" 
            >
              -- niemand --
            </b-form-select-option>
          </template>
        </b-select>
      </template>
      <template #cell(Auditor)="row">
        <inspecteur-select
          :value="row.item.Gecontroleerd_Door"
          :allow-beheerders="true"
          :eigen-groep-alleen="true"
          @input="row.item.Gecontroleerd_Door = $event ? { Id: $event.id, Naam: $event.naam } : null"
        />
      </template>
    </b-table>

    <b-button 
      size="lg"
      class="pull-right" 
      variant="primary" 
      @click="startCreating"
    >
      <font-awesome-icon 
        class="mx-2" 
        icon="play-circle"
      />Stappen aanmaken
    </b-button>
  </b-container>
</template>
<script>
import DateInput from '../DateInput.vue'
import UnitSelectie from '../UnitSelectie.vue'
import HinderInput from './HinderInput.vue'
import { trajectenMixin } from "@/mixins/trajectenMixin";
import { serviceMixin } from "@/mixins/serviceMixin";
import InspecteurSelect from '@/components/InspecteurSelect.vue';
import PeriodeHinder from './PeriodeHinder.vue';
import HinderDetails from './HinderDetails.vue';
import Unit from './Unit.vue';
import UnitSelect from '../UnitSelect.vue';

export default {
    name: 'UitvoeringWizard',
    components: {DateInput, UnitSelectie, HinderInput, InspecteurSelect, PeriodeHinder, HinderDetails, Unit, UnitSelect},
    mixins: [trajectenMixin,serviceMixin],
    props: {
        units: {
            type: Array,
            default: () => {}
        },
        trajectId: {
          type: Number,
          default: null
        },
        unit: {
          type: Number,
          default: null
        }
    },
    data() {
        return  {
            filter: null,
            hinder: {
              start: null,
              eind: null,
              periode: 0,
              days: []
            }
        }
    },
    computed: {
        days: function () {
          return Array.from({ length: this.hinder.periode }, (_, i) => i + 1).map((n) => {
              return {
                hinder: [],
                bevestigd: true,
                index: n - 1,
              };
            })
          },
        extraTaken: function() {
          return [...this.uitvoeringtaken].map(
            f => 
            {
              return {
                Omschrijving: f.toString(),
                Toegewezen_Aan: null,
                Gecontroleerd_Door: null,
                Datum: null, 
                Deadline: null,
                Actief: true
              }
            }
          )
        },
        uitvoeringPath: function () {
          return `/management/${this.trajectId}/uitvoering`
        },
        periode: function() {
            if (!this.start) return 0
            if (!this.eind) return 0
            return -this.moment(this.start).diff(this.moment(this.eind), 'days')
        },
        planningTaak: function() {
          return  { 
            Omschrijving: 'Uitvoering', 
            Datum: this.hinder.start, 
            Actief: true,
            Hinder: this.hinder,
            Unit: this.unit,
          }
        },
        overzicht: function() {
          return [ this.planningTaak ].concat(this.extraTaken.filter(s => s.Actief))
        }
    },
    watch: {},
    mounted () {
        
    },
    methods: {
      onUpdatePeriode(periode) {
        console.log("Periode aangepast ", periode);
        this.hinder.periode = periode
        this.hinder.days = [...this.days]
      },
      tbodyTrClass(item, type) {
        if (type == "row-details") return "bg-gray-500";
        var dow = this.moment(this.hinder.start).add(item.index, 'days').day();
        console.log(dow);
        //if (item._showDetails) return "bg-dark";
        if (dow == 0 || dow == 6) return "bg-gray-600";  
        return null;
      },
      startCreating() {
        var data ={
          hoofdtaak: this.planningTaak,
          additioneel: this.extraTaken.filter(s => s.Actief)
        }
        console.log(data);
        // this.$emit('start-uitvoering',data)
        this.insertUitvoering(data);
      },
      insertUitvoering(obj) {
        var vm = this;
        this.post(this.uitvoeringPath, obj)
          .then(function (response) {
            console.log("Loaded", response.data);
            vm.$emit('uitvoering-completed', response.data)
            // vm.opdracht.events.push(...response.data.planning);
          })
          .catch(function (error) {
            console.log("Error --", error);
          })
          .finally(() => {
            // vm.selectedTab = 0;
          });
      },
    },

          
}
</script>
